import cn from 'classnames';
import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import * as Routes from 'helpers/routes';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import { TEMPO } from 'lib/constants';

const CTABanner = ({ showUnconvertedLead, mealPlanSlug }) => {
  const { brand } = useContext(BrandContext);
  const isTempo = mealPlanSlug === TEMPO;
  const handleButtonClickWithAnalytics = useAnalyticsCallback(
    null,
    ({ logEvent, events }) => {
      logEvent(events.menuSearch.recipeSearchSignupClicked);
    },
    []
  );
  return (
    <aside className={showUnconvertedLead && !isTempo ? 'mb-2 bg-green-50' : 'mb-2 bg-white-100'}>
      <div className="flex min-h-20 flex-col content-center rounded shadow-md bp1:flex-row">
        <div className="flex-1 p-4">
          <hgroup>
            <h1
              className={cn('h4', {
                'font-semibold text-green-100': !isTempo,
                'text-tempo-blue-90': isTempo,
              })}
            >
              Like What You See?
            </h1>

            {showUnconvertedLead ? (
              <h2
                className={cn('text', {
                  'text-green-110': !isTempo,
                  'text-tempo-blue-90': isTempo,
                })}
              >
                {isTempo
                  ? `You’re just
                a few steps away from getting easy, wholesome meals delivered to your door.`
                  : `You’re just
                a few steps away from becoming a Home Chef!`}
              </h2>
            ) : (
              <h2 className="text text-charcoal-90">Sign up and start receiving meals.</h2>
            )}
          </hgroup>
        </div>
        <div className="px-4 pb-4 pt-1 bp1:pt-5">
          <a
            href={Routes.getBrandRoute({ brand: brand }).intro}
            className="btnPrimary btn bp1:btnLg rounded"
            onClick={handleButtonClickWithAnalytics}
          >
            {showUnconvertedLead ? 'Complete Sign Up' : 'Plan Your First Week'}
          </a>
        </div>
      </div>
    </aside>
  );
};

CTABanner.propTypes = {
  showUnconvertedLead: PropTypes.bool.isRequired,
  mealPlanSlug: PropTypes.string,
};

export default CTABanner;
